import fetch from "./sessionFetch";
import { authHeaders, baseUrl, handleResponse } from "./apiUtils";
import { getStoredAuthIdentity } from "./authTokenStorage";

async function request(method, view) {
  const token = getStoredAuthIdentity();
  if (!token) throw new Error("Sesja wygasła. Zaloguj się ponownie.");
  const response = await fetch(`${baseUrl}account/calendar-view`, {
    method,
    headers: authHeaders({ "content-type": "application/json" }),
    ...(method === "PUT" ? { body: JSON.stringify({ calendarView: view }) } : {}),
  });
  // In particular, an old 401 must not clear a newer account's token.
  if (getStoredAuthIdentity() !== token) throw new Error("Sesja została zmieniona.");
  return handleResponse(response);
}

export default {
  getCalendarView: () => request("GET"),
  saveCalendarView: view => request("PUT", view),
};
